import { createAnalytics } from "./analyticsClient";
import i18n from "../locales/i18n";

const read = (key) => { try { return localStorage.getItem(key); } catch { return null; } };
const base = (process.env.REACT_APP_BASEURL || `${window.location.origin}/api`).replace(/\/$/, "");
export const analytics = createAnalytics({
    app: "kiosk", endpoint: `${base}/api/v1/analytics/events`, language: () => i18n.language,
    credentials: () => {
        const token = read("access_token");
        const device = read("deviceToken");
        return { ...(token ? { Authorization: `Bearer ${token}` } : {}),
            ...(device ? { "Device-Token": device } : {}) };
    },
});
export const trackEvent = analytics.track;
export function initAnalytics() {
    analytics.init();
    analytics.languageChanged(i18n.language);
    i18n.on("languageChanged", analytics.languageChanged);
    // VerifyUser used to obtain this token only on the login screen.
    if (window.electronAPI?.getDeviceToken) {
        Promise.resolve().then(() => window.electronAPI.getDeviceToken()).then((token) => {
            if (token) { try { localStorage.setItem("deviceToken", token); } catch { /* optional */ } }
            void analytics.flush();
        }).catch(() => {});
    }
}
